import { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";

import { cn } from "@bentolabs/kit/utils";
import { useChainId } from "wagmi";

import { CurrencyLabel } from "entities/currency";
import { bentoUSDConfig } from "shared/config/const";
import { Button } from "shared/ui/button";
import { Collapsible } from "shared/ui/collapsible";
import { Table } from "shared/ui/table";

type Props = {
  className?: string;
};

export const BasketAssetsDetails = (props: Props) => {
  const { className } = props;
  const chainId = useChainId();
  const [isOpen, setIsOpen] = useState(false);
  const bento = bentoUSDConfig[chainId];

  return (
    <Collapsible
      className={cn("flex flex-col", className)}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Collapsible.Trigger asChild>
        <Button
          className="mx-auto"
          variant="nobel/5"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {isOpen ? (
            <>
              Hide <FaCaretUp />
            </>
          ) : (
            <>
              See assets <FaCaretDown />
            </>
          )}
        </Button>
      </Collapsible.Trigger>
      <Collapsible.Content>
        <Table>
          <Table.Item
            label={
              <CurrencyLabel {...bento} variant="normal" color="transparent" />
            }
            value="25 USDT"
          />
          <Table.Item
            label={<CurrencyLabel />}
            value={
              <span className="flex gap-x-1.5">
                25 USDT <span className="text-nobel/70">($25.3)</span>
              </span>
            }
          />
        </Table>
      </Collapsible.Content>
    </Collapsible>
  );
};
